<template>
    <div>
        <div class="text-center mb-3">
            <p class="h4">
                {{ $t('bases.url_gracias') }}
            </p>
            <p>
                {{ $t("gracias.n_pedido") }}:
                <b>{{ tpv_order }}</b>
            </p>
            <router-link :to="{ name: 'front.home' }" class="button large-button effect-button">
                <span>{{ $t('bases.volver_inicio') }}</span>
            </router-link>
        </div>
        <div class="lightgray-content p-4 small-font mb-2 border-bottom d-flex">
            <div class="d-flex w-100 justify-content-between">
                <div>
                    <div class="mb-3">
                        <span class="h3 text-italicy">
                            {{ $t('bases.categoria') }}: {{ localData.categoria }}
                        </span>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h6>{{ $t("bases.deportista") }}</h6>
                                <div>
                                    <label>
                                        {{ $t("bases.nombre") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.nombre }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.apellidos") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.apellidos }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.email") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.email }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.DNI") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.dni }}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-12">
                                <h6>{{ $t("bases.responsable") }}</h6>
                                <div>
                                    <label>
                                        {{ $t("bases.nombre") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.responsable_1.nombre }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.apellidos") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.responsable_1.apellidos }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.email") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.responsable_1.email }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.DNI") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.responsable_1.dni }}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12 mt-3" v-if="localData.responsable_2?.nombre">
                                <h6>{{ $t("bases.responsable2") }}</h6>
                                <div>
                                    <label>
                                        {{ $t("bases.nombre") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.responsable_2.nombre }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.apellidos") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.responsable_2.apellidos }}
                                        </strong>
                                    </span>
                                </div>
                                <div >
                                    <label>
                                        {{ $t("bases.email") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.responsable_2.email }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.DNI") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.responsable_2.dni }}
                                        </strong>
                                    </span>
                                </div>
                            </div>                       
                        </div>
                        <div class="row mt-2 mb-2" v-if="localData.representante">
                            <div class="col-12 col-md-12">
                                <h6>{{ $t("bases.entrenador") }}</h6>
                                <div>
                                    <label>
                                        {{ $t("bases.nombre") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.representante.name }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.apellidos") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.representante.surnames }}
                                        </strong>
                                    </span>
                                </div>
                                <div >
                                    <label>
                                        {{ $t("bases.email") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.representante.email }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.DNI") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ localData.representante.nif }}
                                        </strong>
                                    </span>
                                </div>
                            </div>      
                        </div>
                    </div>
                    <b-row v-if="localData.indumentariasElegidas?.length > 0">
                        <b-col cols="12" class="h3 text-italicy">
                            {{ $t('bases.indumentarias') }}:
                        </b-col>
                        <b-col cols="12" class="mt-2 ml-3">
                            <strong>
                                {{ localData.indumentariasElegidas.length > 1 ? localData.indumentariasElegidas.map(i => i.nombre).join(', ') : localData.indumentariasElegidas.map(i => i.nombre).join('') }}
                            </strong>
                        </b-col>
                    </b-row>
                    <div>
                        <a
                            :href="localData.url_descarga"
                            class="mt-2 button button-xs"
                            :class="{ 'ml-3': localData.indumentariasElegidas?.length }"
                            target="_blank"
                        >
                            DESCARGAR PDF
                        </a>
                    </div>
                    <div class="mt-4" v-if="localData?.plazos">
                        <span class="h3 text-italicy">
                            Plazos restantes:
                        </span>
                        <div class="mt-3 ml-3">
                            <template v-for="(plazo, index) in localData.plazos">
                                <div :key="index">
                                    <template v-if="localData.indumentaria_plazos">
                                        <p class="p-0 mt-1 h5" style="font-size: 18px;">
                                            {{ $t('bases.n_plazo_sin_gd', { dia: plazo.dia, importe_sin_gd: $n(plazo.importe_base, "currency")}) }}
                                            <span class="d-block h6 mt-1" style="font-size: 14px;">
                                                {{ $t('bases.importe_indumentaria') }}: {{ $n(plazo.importe_indumentaria, 'currency') }}
                                            </span>
                                        </p>
                                    </template>
                                    <p v-else class="p-0 mt-1 h5" style="font-size: 18px;">
                                        {{ $t('bases.n_plazo_sin_gd', { dia: plazo.dia, importe_sin_gd: $n(plazo.importe, "currency")}) }}
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                
                <div class="text-center d-flex flex-column align-items-center">
                    <label class="mb-1">
                        <template v-if="!localData.activar_pago_plazos || !localData.plazos">
                            {{ $t("gracias.precio") + ' total' }}
                        </template>
                        <template v-else>
                            {{ $t("gracias.primer_plazo") }}
                            <template v-if="localData.indumentariasElegidas?.length && !localData.indumentaria_plazos">
                                {{ $t("gracias.mas_indumentarias") }}
                            </template>
                        </template>
                    </label>

                    <template v-if="localData.indumentaria_plazos && localData.plazos?.length">
                        <div class="h5 m-0">
                            {{ $t('bases.precio_base') }}: {{ localData.plazos[0].importe_base | formatear_precio }}
                        </div>
                        <div class="h5 m-0">
                            {{ $t('bases.importe_indumentaria') }}: {{ localData.plazos[0].importe_indumentaria | formatear_precio }}
                        </div>
                    </template>

                    <span class="h1">
                        <span class="ml-2 m-0">
                            {{ localData.importe | formatear_precio }}
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <span>
            <b>{{ $t("gracias.cuestion", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}</b>
        </span>
    </div>
</template>

<script>
    export default {
        props: ['base', 'tpv_order'],
        data() {
            return {
                localData: { ...this.base }
            }
        },
        created() {
            if (this.localData.plazos) {
                this.localData.plazos.shift();
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            }
        }
    }    
</script>